export default {
  'progress.prefix': 'Stap',
  'summary.target-date': 'Date prévue',
  'summary.other-situation-values.box-street': 'Je souhaite déplacer ou supprimer une <b>Armoire de trottoir dans la rue.</b>',
  'summary.other-situation-values.box-facade': 'Je souhaite déplacer ou supprimer un <b>Boîtier réseau en rue.</b>',
  'summary.other-situation-values.connector-cable': 'Je souhaite déplacer ou supprimer un <b>Point de raccordement sur une façade ou un poteau.</b>',
  'summary.other-situation-values.pole': 'Je souhaite déplacer ou supprimer un <b>Câble réseausur une façade, sur un poteau ou jusqu’à votre domicile.</b>',
  'date.proceed': 'Continuez avec cette date',
  'date.confirm': 'Confirmez la date choisie.',
};
